var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","size":"mini","loading":_vm.loading,"disabled":_vm.order.paid || _vm.order.status === 'E'},on:{"click":_vm.onClick}},[_vm._v(" Confirm Availability ")])}
var staticRenderFns = []

export { render, staticRenderFns }